/**
 * Kyros header: mobile menu toggle + Escape to close + accordion behavior
 */
(function () {
  const toggleBtn = document.querySelector('[data-kyros-mobile-toggle]');
  const openBtn = document.querySelector('[data-kyros-mobile-open]');
  const closeBtn = document.querySelector('[data-kyros-mobile-close]');
  const overlay = document.querySelector('[data-kyros-mobile-overlay]');
  if (!overlay) return;

  const triggerBtn = toggleBtn || openBtn;
  if (!triggerBtn) return;

  function isOpen() {
    return overlay.classList.contains('is-open');
  }

  function setExpanded(expanded) {
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openMobile() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden', 'kyros-mobile-menu-open');
    setExpanded(true);
    const focusTarget = overlay.querySelector('[data-kyros-mobile-close]') || closeBtn;
    focusTarget && focusTarget.focus();
  }

  function closeMobile() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden', 'kyros-mobile-menu-open');
    setExpanded(false);
    triggerBtn && triggerBtn.focus();
  }

  triggerBtn.addEventListener('click', function () {
    if (isOpen()) {
      closeMobile();
    } else {
      openMobile();
    }
  });

  closeBtn && closeBtn.addEventListener('click', closeMobile);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeMobile();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      closeMobile();
    }
  });

  // Close the drawer after the user taps a navigation link (not expand buttons)
  overlay.querySelectorAll('a[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      // Keep menu open briefly only for hash-less same-page; otherwise close
      closeMobile();
    });
  });

  overlay.querySelectorAll('[data-kyros-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = !next;
    });
  });
})();
